// questionnaire.effects.ts
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, mergeMap } from 'rxjs/operators';
import { SubmissionsService } from '../services/submissions.service';
import * as QuestionnaireActions from './questionnaire.actions';

@Injectable()
export class QuestionnaireEffects {
  private readonly _actions$ = inject(Actions);
  private readonly _submissionsService = inject(SubmissionsService);
  //ERM-4730: Removed redundant tap(() => this.submissionsService.updateSubmissionStatus()) to eliminate duplicate api calls trigerring
  markModule$ = createEffect(() =>
    this._actions$.pipe(
      ofType(QuestionnaireActions.markModuleSuccess),
      mergeMap(() =>
        this._submissionsService.updateSubmissionStatus().pipe(
          mergeMap(() => of(QuestionnaireActions.noop())),
          catchError(() => of(QuestionnaireActions.noop())),
        ),
      ),
    ),
  );

  //ERM-4730: Removed redundant tap(() => this.submissionsService.updateSubmissionStatus()) to eliminate duplicate api calls trigerring
  markAnswer$ = createEffect(() =>
    this._actions$.pipe(
      ofType(QuestionnaireActions.saveAnswerMarkSuccess),
      mergeMap(() =>
        // Call the service method to update the submission status
        this._submissionsService.updateSubmissionStatus().pipe(
          mergeMap(() => of(QuestionnaireActions.noop())),
          catchError(() => of(QuestionnaireActions.noop())),
        ),
      ),
    ),
  );
}
